import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';
import { InputModel } from '../models/input/input.model';
import { InputStylingModel } from '../models/input/input-styling.model';
import { DatatableModel } from '../models/datatable/datatable.model';
import { DatatableStylingModel } from '../models/datatable/datatable-styling.model';

export const /** @type {?} */ DatatableTemplates = {
  defaultTemplate: {
    property: new DatatableModel({
      display: true,
      disable: false,
      showTableFooter: true,
      showTableCount: true,
      showTablePager: true,
      headerHeight: 42,
      footerHeight: 42,
      rows: [],
      rowHeight: 50,
      columnMode: 'force',
      limit: 3,
      expandable: false,
      rowExpand: 'multiple',
      detailsHeight: 130,
      expandIcon: new IconModel({ name: 'keyboard_arrow_right', size: '16px' }),
      collapseIcon: new IconModel({ name: 'keyboard_arrow_down', size: '16px' }),
      selectable: false,
      sorted: [],
      selected: []
    }),
    style: new DatatableStylingModel({
      expandIcon: new IconStylingModel({ icon: {themeColor: 'primary'} }),
      collapseIcon: new IconStylingModel({ icon: {themeColor: 'primary'} }),
      header: { class: '', dynamicClass: '' },
      footer: { class: '', dynamicClass: '' }
    })
  },
  allDatatableOptions: {
    property: new DatatableModel({
      display: true,
      disable: false,
      showTableFooter: true,
      showTableCount: true,
      showTablePager: true,
      headerHeight: 42,
      footerHeight: 42,
      rows: [],
      rowHeight: 50,
      columnMode: 'force',
      limit: 3,
      expandable: true,
      detailsHeight: 130,
      expandIcon: new IconModel({ name: 'keyboard_arrow_right', size: '16px' }),
      collapseIcon: new IconModel({ name: 'keyboard_arrow_down', size: '16px' }),
      selectable: true,
      sorted: [],
      selected: []
    }),
    style: new DatatableStylingModel({
      expandIcon: new IconStylingModel({ icon: {themeColor: 'primary'} }),
      collapseIcon: new IconStylingModel({ icon: {themeColor: 'primary'} }),
      header: { class: '', dynamicClass: '' },
      footer: { class: '', dynamicClass: '' }
    })
  }
}
